package org.example.zone360.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowDown
import com.varabyte.kobweb.silk.components.icons.fa.FaArrowUp
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.example.zone360.utils.getWidgetDetail
import kotlinx.browser.window
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.CoachTalkRatioData
import org.example.zone360.models.WidgetDetailPayload
import org.example.zone360.models.WidgetDetailResponse
import org.example.zone360.pages.dashboard.chart.GaugeChart
import org.example.zone360.theme.Palette
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.AppGlobal
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import kotlin.math.absoluteValue

@Composable
fun CoachTalkDetailsModal(
    widgetNo: Int,
    widgetName: String,
    widgetColor: Color,
    widgetGaugeID: String,
    data: CoachTalkRatioData,
    coaches: WidgetDetailResponse?,
    isTalk: Boolean,
    minTarget: Int,
    maxTarget: Int,
    statusText: String,
    widgetKey: String,
    statusColor: Color,
    onClose: () -> Unit
) {
    val sitePalette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()
    var selectedSortColumn by remember { mutableStateOf<String?>(null) }
    var isAscending by remember { mutableStateOf(true) }
    var widgetDetailResponse by remember { mutableStateOf<WidgetDetailResponse?>(null) }
    var isLoading by remember { mutableStateOf(false) }
//    var animatedValue by remember { mutableStateOf(0) }
//
//    LaunchedEffect(data.value) {
//
//        if (data.value > 0) {
//            for (i in 0..data.value) {
//                animatedValue = i
//                delay(5) // speed
//            }
//
//        } else {
//            animatedValue = 0
//        }
//    }

    LaunchedEffect(Unit) {
        isLoading = true
        try {
            widgetDetailResponse = getWidgetDetail(
                WidgetDetailPayload(
                    organization = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId,
                    widgetKey = widgetKey
                )
            )
        } catch (e: Exception) {
            debugPrintln("Failed to fetch widget detail: ${e.message}")
        } finally {
            isLoading = false
        }
    }

    val effectiveData = coaches ?: widgetDetailResponse
    val coachList = effectiveData?.coaches ?: emptyList()
    // Full-screen backdrop
    Box(
        modifier = Modifier.fillMaxSize()
            .styleModifier {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                property("right", "0")
                property("bottom", "0")
                property("z-index", "99999")
                property("background-color", "rgba(0,0,0,0.7)")
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
            }
            .onClick { onClose() }
    ) {
        // Content panel - clicks inside should not close the modal
        Box(
            modifier = Modifier
                .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                .borderRadius(16.px)
                .overflow(Overflow.Auto)
                .padding(24.px, if (breakpoint < Breakpoint.MD) 15.px else 25.px)
                .styleModifier {
                    property("width", "90%")
                    property("max-width", "480px")
                    property("max-height", "90vh")
                    property("box-shadow", "0 20px 50px rgba(0,0,0,0.25)")
                }
                .onClick { it.stopPropagation() }
        ) {
            Column(modifier = Modifier.fillMaxWidth()) {

                // Header row: badge + title + close
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth().margin(bottom = 16.px)
                ) {
                    Box(
                        modifier = Modifier
                            .width(28.px)
                            .height(28.px)
                            .backgroundColor(widgetColor)
                            .borderRadius(6.px)
                            .margin(right = 10.px),
                        contentAlignment = Alignment.Center
                    ) {
                        FieldTitleTextNormalSimple(
                            text = widgetNo.toString(),
                            fontSize = 14.px,
                            fontWeight = 700,
                            color = sitePalette.bodyBackgroundSecondary.rgb
                        )
                    }
                    FieldTitleTextNormalSimple(
                        text = widgetName,
                        fontSize = 18.px,
                        fontWeight = 700
                    )
                    Box(modifier = Modifier.styleModifier { property("flex", "1") })
                    Box(
                        modifier = Modifier
                            .cursor(Cursor.Pointer)
                            .onClick { onClose() }
                    ) {
                        SpanText(
                            text = "✕",
                            modifier = Modifier.fontSize(18.px).fontWeight(700)
                        )
                    }
                }

                // Gauge + target/status column
                Row(
                    modifier = Modifier.fillMaxWidth()
                        .margin(
                            bottom = 16.px,
                            top = if (breakpoint < Breakpoint.MD) (-20).px else 0.px
                        )
                        .gap(22.px),
                    verticalAlignment = Alignment.CenterVertically
                ) {

                    GaugeChart(
                        chartId = widgetGaugeID,
                        value = if (isLoading) 0 else data.value,
                        minTarget = minTarget,
                        maxTarget = maxTarget,
                        clubAvg = if (isLoading) null else data.clubAverage
                    )

                    Column(
                        modifier = Modifier.margin(top = 35.px),
                        verticalArrangement = Arrangement.Top,
                        horizontalAlignment = Alignment.Start
                    ) {

                        FieldTitleTextNormalSimple(
                            text = if (isLoading) "" else data.target,
                            fontSize = if (breakpoint < Breakpoint.MD) 20.px else 25.px,
                            fontWeight = 600,
                            color = widgetColor
                        )

                        if (!isLoading) {

                            val statusIcon = when (statusText) {
                                "Accurate", "High" -> "✓"
                                "Low" -> "✕"
                                else -> "✓"
                            }

                            Row(
                                verticalAlignment = Alignment.CenterVertically
                            ) {

                                FieldTitleTextNormalSimple(
                                    text = "Status: $statusText",
                                    fontSize = 16.px,
                                    fontWeight = 700,
                                    color = statusColor
                                )

                                Box(
                                    modifier = Modifier
                                        .margin(left = 6.px)
                                        .width(20.px)
                                        .height(20.px)
                                        .borderRadius(50.percent)
                                        .backgroundColor(
                                            when (statusText) {
                                                "Accurate", "High" -> Palette.CoachTalkSuccessGreen.rgbLight
                                                "Low" -> Palette.CoachTalkErrorRed.rgbLight
                                                else -> statusColor
                                            }
                                        ),
                                    contentAlignment = Alignment.Center
                                ) {
                                    SpanText(
                                        text = statusIcon,
                                        modifier = Modifier
                                            .fontSize(12.px)
                                            .fontWeight(700)
                                            .color(Palette.White.rgbLight)
                                    )
                                }
                            }
                        }
                    }
                }
//                if (isLoading) {
//                    Box(
//                        modifier = Modifier
//                            .fillMaxWidth()
//                            .height(300.px),
//                        contentAlignment = Alignment.Center
//                    ) {
//                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
//                           ProgressIndicator(size = 20.px)
//                        }
//                    }
//                } else
//                {
//                    Row(
//                        modifier = Modifier.fillMaxWidth().margin(
//                            bottom = 16.px,
//                            top = if (breakpoint < Breakpoint.MD) (-20).px else 0.px
//                        )
//                            .gap(22.px),
//                        verticalAlignment = Alignment.CenterVertically
//                    ) {
//                        GaugeChart(
//                            chartId = widgetGaugeID,
//                            value = data.value,
//                            minTarget = minTarget,
//                            maxTarget = maxTarget,
//                            clubAvg = data.clubAverage
//                        )
//
//                        Column(
//                            modifier = Modifier.margin(top = 35.px),
//                            verticalArrangement = Arrangement.Top,
//                            horizontalAlignment = Alignment.Start
//                        ) {
//                            FieldTitleTextNormalSimple(
//                                text = data.target,
//                                fontSize = if (breakpoint < Breakpoint.MD) 20.px else 25.px,
//                                fontWeight = 600,
//                                color = widgetColor
//                            )
//
//                            val statusIcon = when (statusText) {
//                                "Accurate" -> "✓"
//                                "High" -> "✓"
//                                "Low" -> "✕"
//                                else -> "✓"
//                            }
//                            SpanText(
//                                text = statusIcon,
//                                modifier = Modifier
//                                    .fontSize(12.px)
//                                    .fontWeight(700)
//                                    .color(Palette.White.rgbLight)
//                            )
//                            Row(
//                                verticalAlignment = Alignment.CenterVertically,
//                                modifier = Modifier
//                            ) {
//                                FieldTitleTextNormalSimple(
//                                    text = "Status: $statusText",
//                                    fontSize = 16.px,
//                                    fontWeight = 700,
//                                    color = statusColor
//                                )
//                                Box(
//                                    modifier = Modifier
//                                        .margin(left = 6.px)
//                                        .width(20.px)
//                                        .height(20.px)
//                                        .borderRadius(50.percent)
//                                        .backgroundColor(
//                                            when (statusText) {
//                                                "Accurate" -> Palette.CoachTalkSuccessGreen.rgbLight
//                                                "High" -> Palette.CoachTalkSuccessGreen.rgbLight
//                                                "Low" -> Palette.CoachTalkErrorRed.rgbLight
//                                                else -> statusColor
//                                            }
//                                        ),
//                                    contentAlignment = Alignment.Center
//                                ) {
//                                    SpanText(
//                                        text = statusIcon,
//                                        modifier = Modifier
//                                            .fontSize(12.px)
//                                            .fontWeight(700)
//                                            .color(Palette.White.rgbLight)
//                                    )
//                                }
//                            }
//                        }
//                    }
//                }
                fun calculateGap(
                    score: Int,
                    minTarget: Int,
                    maxTarget: Int
                ): Int {
                    return when {
                        score < minTarget -> score - minTarget
                        score > maxTarget -> score - maxTarget
                        else -> 0
                    }
                }

                // ✅ Sort safely
                val sortedCoaches = when (selectedSortColumn) {
                    "COACH" -> {
                        if (isAscending)
                            coachList.sortedBy { it.coachName.lowercase() }
                        else
                            coachList.sortedByDescending { it.coachName.lowercase() }
                    }
                    "SCORE", "TALK %" -> {
                        if (isAscending)
                            coachList.sortedBy { it.score }
                        else
                            coachList.sortedByDescending { it.score }
                    }
                    "GAP" -> {
                        if (isAscending)
                            coachList.sortedBy {
                                calculateGap(it.score.toInt(), minTarget, maxTarget)
                            }
                        else
                            coachList.sortedByDescending {
                                calculateGap(it.score.toInt(), minTarget, maxTarget)
                            }
                    }
                    else -> coachList
                }

                // Table header
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .borderRadius(12.px)
                        .overflow(Overflow.Auto)
                        .styleModifier {
                            property("border", "1px solid #E5EAF3")
                            property("overflow", "auto")
                        }
                )
                {
                    // HEADER

                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .gap(10.px)
                            .backgroundColor(Color.rgb(248, 250, 252))
                            .padding(leftRight = 20.px, topBottom = 10.px)
                            .borderBottom(
                                1.px,
                                LineStyle.Solid,
                                Color.rgb(229, 234, 243)
                            ),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {

                        val headers = listOf(
                            "COACH",
                            if (isTalk) "TALK %" else "SCORE",
                            "TARGET",
                            "GAP"
                        )

                        headers.forEachIndexed { index, label ->
                            Row(
                                modifier = Modifier
                                    .width(
                                        when {
                                            index == 0 && window.screen.width < 768 -> 115.px
                                            index == 0 -> 170.px
                                            else -> 80.px
                                        }
                                    )
                                    .cursor(Cursor.Pointer)
                                    .onClick {

                                        if (selectedSortColumn == label) {
                                            isAscending = !isAscending
                                        } else {
                                            selectedSortColumn = label
                                            isAscending = true
                                        }
                                    },
                                verticalAlignment = Alignment.CenterVertically
                            ) {

                                FieldTitleTextNormalSimple(
                                    text = label,
                                    fontSize = 11.px,
                                    fontWeight = 700,
                                    color = Color.rgb(107, 114, 128)
                                )

                                if (selectedSortColumn == label) {
                                    Box(
                                        modifier = Modifier.margin(left = 5.px)
                                    ) {
                                        if (isAscending) {
                                            FaArrowUp(
                                                modifier = Modifier
                                                    .fontSize(10.px)
                                                    .color(Palette.CoachHeaderGradientOne.rgbLight)
                                            )
                                        } else {
                                            FaArrowDown(
                                                modifier = Modifier
                                                    .fontSize(9.px)
                                                    .color(Palette.CoachHeaderGradientOne.rgbLight)
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // BODY

                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(315.px)
                            .overflow(Overflow.Auto)
                    ) {

                        sortedCoaches.forEachIndexed { rowIndex, coach ->

                            val gap = calculateGap(
                                score = coach.score.toInt(),
                                minTarget = minTarget,
                                maxTarget = maxTarget
                            )

                            val gapPositive = gap >= 0
                            val avatarColor = getAvatarColor(coach.coachName)

                            Row(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .gap(10.px)
                                    .backgroundColor(
                                        if (rowIndex % 2 == 0)
                                            Colors.White
                                        else
                                            Color.rgb(250, 251, 252)
                                    )
                                    .padding(leftRight = if (breakpoint < Breakpoint.MD) 10.px else 20.px, topBottom = 10.px)
                                    .borderBottom(
                                        1.px,
                                        LineStyle.Solid,
                                        Color.rgb(241, 245, 249)
                                    ),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {

                                // Coach

                                Row(
                                    modifier = Modifier.width(if (window.screen.width < 768) 90.px else 190.px),
                                    verticalAlignment = Alignment.CenterVertically
                                ) {

                                    val initials = coach.coachName
                                        .split(" ")
                                        .take(1)
                                        .joinToString("") {
                                            it.firstOrNull()?.toString() ?: ""
                                        }
                                        .uppercase()

                                    Box(
                                        modifier = Modifier
                                            .width(if (breakpoint < Breakpoint.MD) 25.px else 32.px)
                                            .height(if (breakpoint < Breakpoint.MD) 25.px else 32.px)
                                            .backgroundColor(avatarColor.bg)
                                            .borderRadius(50.percent)
                                            .margin(right = 10.px),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        SpanText(
                                            text = initials,
                                            modifier = Modifier
                                                .fontSize(11.px)
                                                .fontWeight(700)
                                                .color(avatarColor.text)
                                        )
                                    }

                                    SpanText(
                                        text = coach.coachName,
                                        modifier = Modifier
                                            .fontSize(13.px)
                                            .fontWeight(500)
                                            .overflow(Overflow.Hidden)
                                            .whiteSpace(WhiteSpace.NoWrap)
                                            .then(
                                                if (breakpoint < Breakpoint.MD) {
                                                    Modifier.width(60.px)
                                                } else {
                                                    Modifier // No width applied
                                                }
                                            )
                                            .styleModifier {
                                                property("text-overflow", "ellipsis")
                                            }
                                    )
                                }

                                // Score

                                FieldTitleTextNormalSimple(
                                    text = "${coach.score}%",
                                    width = 80.px,
                                    fontSize = 11.px,
                                    fontWeight = 500
                                )

                                // Target

                                Box(
                                    modifier = Modifier.width(if (breakpoint < Breakpoint.MD) 102.px else 90.px)
                                ) {
                                    Box(
                                        modifier = Modifier
                                            .backgroundColor(Color.rgb(240, 253, 244))
                                            .borderRadius(6.px)
                                            .padding(leftRight = if (breakpoint < Breakpoint.MD) 4.px else 8.px, topBottom = 4.px)
                                    ) {
                                        FieldTitleTextNormalSimple(
                                            text =  "${minTarget}-${maxTarget}%",
                                            fontSize = 12.px,
                                            fontWeight = 600,
                                            color = Color.rgb(22, 163, 74)
                                        )
                                    }
                                }

                                // GAP

                                Box(
                                    modifier = Modifier.width(if (breakpoint < Breakpoint.MD) 110.px else 95.px)
                                ) {

                                    Box(
                                        modifier = Modifier
                                            .backgroundColor(
                                                if (gapPositive)
                                                    Color.rgba(34, 197, 94, 0.10f)
                                                else
                                                    Color.rgba(239, 68, 68, 0.10f)
                                            )
                                            .borderRadius(6.px)
                                            .padding(leftRight = if (breakpoint < Breakpoint.MD) 4.px else 8.px, topBottom = 4.px)
                                    ) {

                                        Row(
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {

                                            Box(
                                                modifier = Modifier
                                                    .width(16.px)
                                                    .height(16.px)
                                                    .borderRadius(50.percent)
                                                    .backgroundColor(
                                                        if (gapPositive)
                                                            Color.rgb(34, 197, 94)
                                                        else
                                                            Color.rgb(239, 68, 68)
                                                    )
                                                    .margin(right = 6.px),
                                                contentAlignment = Alignment.Center
                                            ) {
                                                SpanText(
                                                    text = if (gapPositive) "✓" else "✕",
                                                    modifier = Modifier
                                                        .fontSize(9.px)
                                                        .fontWeight(700)
                                                        .color(Colors.White)
                                                )
                                            }

                                            FieldTitleTextNormalSimple(
                                                text = "${if (gapPositive) "+" else ""}${gap}%",
                                                fontSize = 12.px,
                                                fontWeight = 600,
                                                marginLeft = if (breakpoint < Breakpoint.MD)(-2).px else 0.px,
                                                color = if (gapPositive)
                                                    Color.rgb(22, 163, 74)
                                                else
                                                    Color.rgb(239, 68, 68)
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

data class AvatarColor(
    val bg: Color,
    val text: Color
)

fun getAvatarColor(name: String): AvatarColor {
    return when ((name.hashCode().absoluteValue % 6)) {
        0 -> AvatarColor(Color.rgb(219, 234, 254), Color.rgb(37, 99, 235))   // Blue
        1 -> AvatarColor(Color.rgb(220, 252, 231), Color.rgb(22, 163, 74))   // Green
        2 -> AvatarColor(Color.rgb(243, 232, 255), Color.rgb(147, 51, 234))  // Purple
        3 -> AvatarColor(Color.rgb(255, 237, 213), Color.rgb(234, 88, 12))   // Orange
        4 -> AvatarColor(Color.rgb(204, 251, 241), Color.rgb(13, 148, 136))  // Teal
        else -> AvatarColor(Color.rgb(252, 231, 243), Color.rgb(219, 39, 119)) // Pink
    }
}